<div class="modal modal_size_488 modal__opened">
  <div class="modal__container">
    <div class="modal__title modal__title-mb12 h2">{{ 'logout-modal.title' | translate }}</div>
    <div class="modal__text">{{ 'logout-modal.text' | translate }}</div>
  </div>
  <div class="modal__buttons-row">
    <div class="button" (click)="logout()">{{ 'logout-modal.logout' | translate }}</div>
    <div class="button button_type_light" (click)="close()">{{ 'logout-modal.cancel' | translate }}</div>
  </div>
</div>
